import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {WarningComponent} from '../warning/warning.component';
import {MatDialog} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-sign-message-dialog',
  templateUrl: './sign-message-dialog.component.html',
  styleUrls: ['./sign-message-dialog.component.scss']
})
export class SignMessageDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SignMessageDialogComponent>,
    public dialog: MatDialog,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    if (this.data && (this.data.reason === '' || !this.data.reason)) {
      this.dialogRef.close(false);
    } else {
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.translateService.instant('sign-message.confirm')
      });
      confirmDialog.afterClosed().subscribe(res => {
        if (res) {
          this.dialogRef.close(false);
        }
      });
    }

  }

  onSubmitWarningForm(data: any) {
    this.dialogRef.close(data);
  }

}
